import React, { useEffect, useState } from "react";
import styled, { keyframes, css } from "styled-components"; // Adicionado 'css'
import { useParams } from "react-router-dom";
import { getFirestore, collection, query, where, onSnapshot, doc, getDoc } from "firebase/firestore";
import { app } from "../firebase";
import { LuClock, LuScissors, LuUser, LuMegaphone, LuStore, LuLayers } from "react-icons/lu";

const db = getFirestore(app);

/* --- ANIMAÇÕES --- */
const pulseBorder = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7); }
  70% { box-shadow: 0 0 0 15px rgba(255, 255, 255, 0); }
  100% { box-shadow: 0 0 0 0 rgba(255, 255, 255, 0); }
`;

const slideIn = keyframes`
  from { transform: translateX(20px); opacity: 0; }
  to { transform: translateX(0); opacity: 1; }
`;

/* --- ESTILOS AZUL/DARK CONTRASTE --- */
const TvContainer = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: #1f1a40;
  color: white;
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  padding: 2rem;
  gap: 2rem;
  box-sizing: border-box;
  overflow: hidden;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;
    padding: 1rem;
    gap: 1rem;
  }
`;

/* --- LADO ESQUERDO: DESTAQUE --- */
const DestaqueCard = styled.div`
  background: #3a79ed;
  border-radius: 2rem;
  box-shadow: 0 10px 40px rgba(58, 121, 237, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 3rem;
  position: relative;
  text-align: center;
  transition: all 0.5s ease;
  
  /* CORREÇÃO DO ERRO ANTERIOR: USANDO css helper */
  ${props => props.isCalling && css`
    animation: ${pulseBorder} 2s infinite;
  `}
`;

const HeaderLogo = styled.div`
  position: absolute;
  top: 2rem;
  left: 2rem;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.5rem;
  font-weight: 700;
  color: white;
  opacity: 0.8;
`;

const PaginationDots = styled.div`
  position: absolute;
  bottom: 2rem;
  display: flex;
  gap: 8px;
`;

const Dot = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${props => props.active ? "white" : "rgba(255,255,255,0.4)"};
  transition: all 0.3s;
`;

const StatusLabel = styled.div`
  background-color: rgba(255, 255, 255, 0.2);
  color: white;
  padding: 0.8rem 2rem;
  border-radius: 50px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-size: 1.5rem;
  margin-bottom: 2rem;
  display: inline-flex;
  align-items: center;
  gap: 10px;
`;

const NomeGigante = styled.h1`
  font-size: 6vw;
  font-weight: 800;
  color: white;
  margin: 0;
  line-height: 1.1;
  text-shadow: 0 4px 10px rgba(0,0,0,0.2);
  
  @media (max-width: 1024px) { font-size: 10vw; }
`;

const ServicoGigante = styled.h2`
  font-size: 2.5vw;
  font-weight: 500;
  color: #d1e2ff;
  margin: 1rem 0 3rem 0;
  @media (max-width: 1024px) { font-size: 5vw; margin-bottom: 1.5rem; }
`;

const BarbeiroCard = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  background: rgba(0, 0, 0, 0.1);
  color: white;
  padding: 1rem 2rem;
  border-radius: 1rem;

  span {
    font-size: 1.5rem;
    font-weight: 600;
    color: white;
  }
`;

/* --- LADO DIREITO: LISTAS --- */
const ListasColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  overflow: hidden;
`;

const SectionBox = styled.div`
  background: #16122e;
  border-radius: 1.5rem;
  box-shadow: 0 4px 20px rgba(0,0,0,0.1);
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  border: 1px solid #3a79ed;
`;

const SectionHeader = styled.div`
  background: #1f1a40;
  padding: 1.2rem 1.5rem;
  font-size: 1.25rem;
  font-weight: 700;
  color: #3a79ed;
  display: flex;
  align-items: center;
  gap: 10px;
  border-bottom: 1px solid #3a79ed;
`;

const ItemsContainer = styled.div`
  padding: 1rem;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;

const TicketRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.2rem;
  background: #2b254d;
  border: 1px solid #3a79ed50;
  border-left: 5px solid ${props => props.borderColor || "#6366f1"};
  border-radius: 0.8rem;
  animation: ${slideIn} 0.4s ease-out;

  .left {
    display: flex;
    flex-direction: column;
    gap: 4px; /* Espaço entre nome e serviço */
  }
  .name {
    font-size: 1.4rem;
    font-weight: 700;
    color: white;
  }
  .service {
    font-size: 0.9rem;
    color: #aeb9cc;
  }
  
  /* Badge do Barbeiro na lista lateral */
  .barber-badge {
    display: flex;
    align-items: center;
    gap: 6px;
    background: rgba(58, 121, 237, 0.2); /* Fundo azul transparente */
    color: #60a5fa; /* Azul claro */
    padding: 6px 12px;
    border-radius: 8px;
    font-weight: 600;
    font-size: 0.85rem;
    border: 1px solid rgba(58, 121, 237, 0.3);
  }
`;

export default function FilaTvPage() {
  const { barbeariaId } = useParams();
  
  // Lista completa de chamados para o carrossel
  const [chamadosLista, setChamadosLista] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const [proximos, setProximos] = useState([]);
  const [emAtendimento, setEmAtendimento] = useState([]);
  const [barbeariaNome, setBarbeariaNome] = useState("");

  useEffect(() => {
    // 1. Buscar nome da barbearia
    getDoc(doc(db, "barbearia", barbeariaId)).then((snap) => {
      if (snap.exists()) setBarbeariaNome(snap.data().nome);
    });

    // 2. Ouvir fila em tempo real
    const q = query(
      collection(db, "barbearia", barbeariaId, "fila"),
      where("status", "in", ["aguardando", "chamado", "em_atendimento"])
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const todos = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
      
      // Ordenar por entrada (para a lista de próximos)
      todos.sort((a, b) => (a.dataEntrada?.seconds || 0) - (b.dataEntrada?.seconds || 0));

      // Filtra chamados
      const chamados = todos.filter(t => t.status === 'chamado');
      // Ordena chamados por hora da chamada (mais recente primeiro)
      chamados.sort((a, b) => (b.horaChamada?.seconds || 0) - (a.horaChamada?.seconds || 0));
      
      setChamadosLista(chamados); // Guarda a lista toda
      setProximos(todos.filter(t => t.status === 'aguardando'));
      setEmAtendimento(todos.filter(t => t.status === 'em_atendimento'));
    });

    return () => unsubscribe();
  }, [barbeariaId]);

  // 3. Efeito de Carrossel para alternar entre chamados
  useEffect(() => {
    if (chamadosLista.length > 1) {
      const interval = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % chamadosLista.length);
      }, 5000); // Troca a cada 5 segundos
      return () => clearInterval(interval);
    } else {
      setCurrentIndex(0); // Se tiver 0 ou 1, reseta
    }
  }, [chamadosLista.length]);

  // O cliente que está sendo exibido no momento (no card grande)
  const displayChamado = chamadosLista.length > 0 ? chamadosLista[currentIndex] : null;

  return (
    <TvContainer>
      {/* --- COLUNA ESQUERDA: DESTAQUE (Carrossel) --- */}
      <DestaqueCard isCalling={!!displayChamado}>
        <HeaderLogo>
            <LuStore /> {barbeariaNome || "Barbearia"}
        </HeaderLogo>

        {displayChamado ? (
          <>
            <StatusLabel>
               <LuMegaphone /> 
               {chamadosLista.length > 1 ? `CHAMANDO (${currentIndex + 1}/${chamadosLista.length})` : "CHAMANDO"}
            </StatusLabel>
            
            <NomeGigante>{displayChamado.clienteNome}</NomeGigante>
            <ServicoGigante>{displayChamado.servicoNome}</ServicoGigante>

            <BarbeiroCard>
               <LuUser size={24} color="#d1e2ff"/>
               <span>{displayChamado.barbeiroNome || "Qualquer Barbeiro"}</span>
            </BarbeiroCard>

            {/* Pontinhos de navegação se houver mais de um */}
            {chamadosLista.length > 1 && (
              <PaginationDots>
                {chamadosLista.map((_, idx) => (
                  <Dot key={idx} active={idx === currentIndex} />
                ))}
              </PaginationDots>
            )}
          </>
        ) : (
          <>
            <StatusLabel style={{background: '#1f1a40', color: '#aeb9cc'}}>
               AGUARDE
            </StatusLabel>
            <div style={{opacity: 0.3, margin: '2rem 0'}}>
                <LuClock size={120} color="white"/>
            </div>
            <h2 style={{color: '#d1e2ff', fontWeight: 500}}>
                Aguardando próxima chamada...
            </h2>
          </>
        )}
      </DestaqueCard>

      {/* --- COLUNA DIREITA: LISTAS --- */}
      <ListasColumn>
        
        {/* Próximos na Fila */}
        <SectionBox style={{flex: 2}}>
            <SectionHeader>
                <LuClock color="#3a79ed"/> Próximos na Fila
            </SectionHeader>
            <ItemsContainer>
                {proximos.length === 0 ? (
                    <div style={{textAlign: 'center', padding: 20, color: '#aeb9cc'}}>Fila Vazia</div>
                ) : (
                    proximos.slice(0, 4).map((ticket, index) => (
                        <TicketRow key={ticket.id} borderColor="#fbbf24">
                            <div className="left">
                                <span className="name">{index + 1}. {ticket.clienteNome}</span>
                                <span className="service">{ticket.servicoNome}</span>
                            </div>
                            
                            {/* Barbeiro na direita */}
                            <div className="barber-badge">
                                <LuUser size={14}/>
                                {ticket.barbeiroNome || "Sem pref."}
                            </div>
                        </TicketRow>
                    ))
                )}
                {proximos.length > 4 && (
                    <div style={{textAlign: 'center', color: '#aeb9cc', fontWeight: 600}}>
                        + {proximos.length - 4} aguardando
                    </div>
                )}
            </ItemsContainer>
        </SectionBox>

        {/* Em Atendimento */}
        <SectionBox style={{flex: 1.5, background: '#100c28', border: '1px solid #10b981'}}>
            <SectionHeader style={{background: '#16122e', color: '#10b981', borderBottom: '1px solid #10b981'}}>
                <LuScissors /> Em Atendimento
            </SectionHeader>
            <ItemsContainer>
                {emAtendimento.length === 0 ? (
                    <div style={{textAlign: 'center', padding: 20, color: '#10b981', opacity: 0.6}}>Ninguém no momento</div>
                ) : (
                    emAtendimento.slice(0, 3).map(ticket => (
                        <TicketRow key={ticket.id} borderColor="#10b981" style={{borderLeftWidth: '5px', background: '#2b254d'}}>
                            <div className="left">
                                <span className="name" style={{fontSize: '1.2rem'}}>{ticket.clienteNome}</span>
                                <span className="service" style={{fontSize: '0.9rem'}}>{ticket.servicoNome}</span>
                            </div>

                             {/* Barbeiro na direita */}
                            <div className="barber-badge" style={{color: '#86efac', borderColor: '#86efac30', background: '#86efac10'}}>
                                <LuUser size={14}/>
                                {ticket.barbeiroNome}
                            </div>
                        </TicketRow>
                    ))
                )}
            </ItemsContainer>
        </SectionBox>

      </ListasColumn>
    </TvContainer>
  );
}